module.exports = __webpack_public_path__ + "img/franchising_help_purchase.d3586f1f.png";